import { AppConfig } from 'AppConfig';
import Auth from 'auth/Auth';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import * as UserTypes from 'features/user/userTypes';
import { checkAuth, dispatchJwt } from './checkAuth';
import routePaths from './routePaths';

const PrivateRoute = ({ component: Component, ...rest }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const jwt = checkAuth();

  useEffect(() => {
    if (jwt) {
      dispatchJwt(jwt);
    } else {
      dispatch({ type: UserTypes.LOGOUT });

      if (Auth.getLoginMode() === Auth.LOGIN_MODE_HST) {
        Auth.removeLoginMode();
        window.location.href = AppConfig.OKTA_URL;
      } else {
        navigate(routePaths.login, { state: { from: location }, replace: true });
      }
    }
  }, [dispatch, jwt, location, navigate]);

  if (jwt) {
    return <Component {...rest} />;
  }

  return null;
};

export default PrivateRoute;
